"use strict";var _interopRequireDefault = require("D:\\work\\svn\\\u5BB6\u7528\u540E\u53F0\\branches\\20240430-1.5.0\\node_modules\\@babel\\runtime/helpers/interopRequireDefault");Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;var _objectSpread2 = _interopRequireDefault(require("D:\\work\\svn\\\u5BB6\u7528\u540E\u53F0\\branches\\20240430-1.5.0\\node_modules\\@babel\\runtime-corejs2/helpers/objectSpread2"));


































var _vuex = require("vuex"); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)({ username: 'getUsername' })), data: function data() {return { tableData: [], // 列表数据
      searchData: { page: 1, // 当前页码
        rows: 10 // 页码条数
      }, pageData: { page: 1, rows: 10, total: 0, pages: 1 }, delIds: '' };}, mounted: function mounted() {var self = this;self.init();}, methods: { init: function init() {var self = this;self.getData('/api/faDeviceInfo/user/483', self.searchData, function (res) {self.tableData = res;self.pageData.page = res.pageNum;self.pageData.total = res.total;});}, handleSizeChange: function handleSizeChange(val) {// 分页条数
      this.searchData.rows = val;
      this.searchData.page = 1;
      this.init();
    },
    handleCurrentChange: function handleCurrentChange(val) {// 分页页码
      this.searchData.page = val;
      this.init();
    },
    handleSelectionChange: function handleSelectionChange(val) {var _this = this;
      this.delIds = '';
      val.map(function (item) {
        _this.delIds += item.id + ',';
      });
    },
    returnFun: function returnFun() {
      // 返回上一级
      this.$router.push('/news/user');
    } } };exports.default = _default;